import moment from 'moment';
import React from 'react'
import { MoneyLogCell } from '../../../../../components/MoneyLogLines'

export const TableRow = (props) => {
  const { id, value, user, createdAt, reason, moneyLog } = props;



  return (
    <tr>
      <td>
        {(user && user.name) || ""}<br />
        <span><strong className={`text-primary`}>{(user && user.phone.replace('+84', '0')) || ""}</strong></span>
      </td>
      <td className="fw-900 text-success text-right">{new Intl.NumberFormat('vn-VI', {}).format(value) || ""}</td>
      <td>
      {reason === 'CUSTOMER_REQUIRED' ? 'Khách hàng yêu cầu' : reason === 'WRONG_CHARGE' ? 'Nhầm lẫn trong lúc nạp' : reason}
      </td>
      <MoneyLogCell moneyLog={moneyLog} expectedType="TransactionRefund" expectedId={id} />
      <td className="text-center">{moment(createdAt || '').format('DD/MM/YYYY HH:mm:ss')}</td>
    </tr>
  );
};
